import React, {useCallback, useEffect, useState} from 'react';
import Button from "../Utils/Button/index.jsx";

import up_arrow from '../../assets/up_arrow.svg';

import './style.scss'


const ScrollToTopButton = () =>{
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = useCallback(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    },[])

    const handleScroll = () => {
        if (window.scrollY > 400) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return isVisible &&  (<Button onClick={scrollToTop} className={'scroll_to_top_btn'}><img src={up_arrow} alt=""/></Button>)
}

export default ScrollToTopButton